import * as React from 'react';
import { createContext, useContext, useState } from 'react';

import { progressNotStarted, progressStarted } from 'pages/open-course/common/constants';

export type LearningEffortFirstPlayContextType = {
  shouldDisableSkippingForward: boolean;
  onVideoPlayedToEnd: () => void;
  learnerMaxVideoProgressInSeconds: number;
  setLearnerMaxVideoProgressInSeconds: React.Dispatch<React.SetStateAction<number>>;
  checkLearnerVideoProgress: (learnerProgress: string, disableSkippingForward: boolean) => void;
  showVideoSkippingDisabledNotification: boolean;
  setShowVideoSkippingDisabledNotification: React.Dispatch<React.SetStateAction<boolean>>;
};

const LearningEffortFirstPlayContext = createContext<LearningEffortFirstPlayContextType>({
  shouldDisableSkippingForward: false,
  onVideoPlayedToEnd: () => undefined,
  learnerMaxVideoProgressInSeconds: 0,
  setLearnerMaxVideoProgressInSeconds: () => undefined,
  checkLearnerVideoProgress: () => undefined,
  showVideoSkippingDisabledNotification: false,
  setShowVideoSkippingDisabledNotification: () => undefined,
});

export const useLearningEffortFirstPlayContext = () => {
  return useContext(LearningEffortFirstPlayContext);
};

export const LearningEffortFirstPlayContextProvider: React.LegacyFunctionComponentWithChildren<{}> = ({ children }) => {
  const [shouldDisableSkippingForward, setShouldDisableSkippingForward] = useState(false);
  const [learnerMaxVideoProgressInSeconds, setLearnerMaxVideoProgressInSeconds] = useState(0);
  const [showVideoSkippingDisabledNotification, setShowVideoSkippingDisabledNotification] = useState(false);

  const checkLearnerVideoProgress = (learnerProgress: string, disableSkippingForward: boolean) => {
    if ((learnerProgress === progressNotStarted || learnerProgress === progressStarted) && disableSkippingForward) {
      setShouldDisableSkippingForward(true);
    }
  };

  const onVideoPlayedToEnd = () => {
    setShouldDisableSkippingForward(false);
  };

  return (
    <LearningEffortFirstPlayContext.Provider
      value={{
        shouldDisableSkippingForward,
        onVideoPlayedToEnd,
        learnerMaxVideoProgressInSeconds,
        setLearnerMaxVideoProgressInSeconds,
        checkLearnerVideoProgress,
        showVideoSkippingDisabledNotification,
        setShowVideoSkippingDisabledNotification,
      }}
    >
      {children}
    </LearningEffortFirstPlayContext.Provider>
  );
};
